import { mapState } from 'vuex'
import Perfil from '@/utils/perfil'

export const computed = {
  ...mapState('auth', ['empresaAtual', 'perfilAtual']),
  ...mapState('agendamentos', ['agendamento']),
  ehGate() {
    return this.empresaAtual.gate && this.perfilAtual == Perfil.Unidade
  },
  class_agendamento() {
    if (this.agendamento.cancelado_em) {
      return 'red--text'
    }
    return
  },
}
